import { Dropdown, Menu, Modal } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import ThreeDot from 'icons/Threedot.svg';
import { localize } from 'mixins/helpers';
import React from 'react';
import { GenerationsData } from '../admin-token-generations';

interface TokenGenerationsColumnsParams {
    translations: Record<string, string>;
    onTokenAction: (
        id: string,
        action: 'block' | 'unblock' | 'delete',
        taxpayerCode?: string
    ) => void;
}

export const getTokenGenerationsColumns = ({
    translations,
    onTokenAction,
}: TokenGenerationsColumnsParams): ColumnsType<GenerationsData> => [
    {
        title: localize('iin', translations),
        dataIndex: 'taxpayerCode',
    },
    {
        title: localize('admin-token-name-org', translations),
        dataIndex: 'name',
    },
    {
        title: localize('admin-token-created-at', translations),
        dataIndex: 'issuedAt',
    },
    {
        title: localize('admin-token-expired-at', translations),
        dataIndex: 'expiredAt',
    },
    {
        title: localize('admin-token-id', translations),
        dataIndex: 'id',
    },
    {
        title: localize('admin-token-blocked', translations),
        dataIndex: 'blocked',
        render: (blocked: boolean) => (
            blocked ? localize('yes', translations) : localize('no', translations)
        ),
    },
    {
        title: localize('actions', translations),
        width: 100,
        render: (_text, record) => (
            <Dropdown
                overlay={
                    <Menu>
                        <Menu.Item
                            disabled={record.blocked}
                            onClick={() => onTokenAction(record.id, 'block')}
                        >
                            {localize('admin-token-action-block', translations)}
                        </Menu.Item>
                        <Menu.Item
                            disabled={!record.blocked}
                            onClick={() => onTokenAction(record.id, 'unblock')}
                        >
                            {localize('admin-token-action-unblock', translations)}
                        </Menu.Item>
                        <Menu.Item
                            danger
                            onClick={() => {
                                Modal.confirm({
                                    title: 'Удаление токена',
                                    content: 'Вы точно хотите удалить токен?',
                                    okText: 'Удалить',
                                    cancelText: 'Отмена',
                                    okButtonProps: {
                                        danger: true,
                                    },
                                    onOk: () =>
                                        onTokenAction(
                                            record.id,
                                            'delete',
                                            record.taxpayerCode
                                        ),
                                });
                            }}
                        >
                            {localize('admin-token-action-delete', translations)}
                        </Menu.Item>
                    </Menu>
                }
            >
                <ThreeDot />
            </Dropdown>
        ),
    },
];